import { UIText3 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './MobileBottomNavigation.css';
import { IMobileNavigationItem } from '../../types/mobileBottomNavigation';

interface IMobileBottomNavigationProps {
  items: IMobileNavigationItem[];
}

export const MobileBottomNavigation: React.FC<IMobileBottomNavigationProps> = ({ items }) => {
  return (
    <div className={styles['bottom-navigation']}>
      {items.map(({ title, link, icon: Icon, isActive, onClick }, index) => (
        <a
          key={index}
          href={link}
          className={clsx(styles['navigation-item'], isActive && styles['navigation-item--active'])}
          onClick={onClick}
        >
          <Icon color="current_color" />
          <UIText3 color="current_color">{title}</UIText3>
        </a>
      ))}
    </div>
  );
};
